import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'selectedContainer' ]

  changeSet(e) {
    const target = e.currentTarget
    if (!target) return
    const option = document.querySelector(`#spots option[value="${target.value.replace(/["\\]/g, '\\$&')}"]`)
    if (!option) return
    const li = document.createElement('li')
    li.classList.add('c-selected-items__item')
    li.innerHTML = this.template(target.value, option.dataset.spot_id)
    this.container.append(li)
    option.remove()
    target.value = ''
  }

  deleteSet(e) {
    const item = e.currentTarget.closest('.c-selected-items__item')
    if (!item) return
    const selected = item.querySelector('.selected_spots')
    if (!selected) return
    const option = document.createElement('option')
    option.setAttribute('data-spot_id', selected.value)
    option.setAttribute('value', selected.dataset.name)
    document.querySelector('#spots').append(option)
    item.remove()
  }

  template(name, spotId) {
    return `<span class="spot-name"> ${name}</span>
<i class="fa fa-times" data-action="click->admin--spot#deleteSet"></i>
<input type="hidden" value="${spotId}" name="plan[spot_ids][]" data-name="${name}" class="selected_spots" />`
  }

  get container() {
    return this.selectedContainerTarget
  }
}
